import { ReactComponent as FlagIcon } from "./svg/mn-flag.svg";
import "../flag-icon.scss";

export const MNFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
